// --------------------------------------------------------------------
// @author: shiraho@syg.com(必填, 创建模块的人员)
// @description:
//      按钮播放音效的
// <br/>Create: new Date().toISOString()
// --------------------------------------------------------------------
var PlayEffect = cc.Class({
    extends: cc.Component,

    properties: {
    },

    ctor: function() {

    },

    start () {

    },
});
